import { render, staticRenderFns } from "./EOIBenefits.vue?vue&type=template&id=ca6fb624&scoped=true&"
import script from "./EOIBenefits.vue?vue&type=script&lang=js&"
export * from "./EOIBenefits.vue?vue&type=script&lang=js&"
import style0 from "./EOIBenefits.vue?vue&type=style&index=0&id=ca6fb624&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6fb624",
  null
  
)

export default component.exports